import { toCamelCase } from '../utils/caseConverter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const uploadQuotation = async (data: FormData) => {
  const response = await fetch(`${API_BASE_URL}/api/quotations`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: data,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`Upload failed: ${error}`);
  }
};

export const fetchQuotationsForAQuery = (queryID: number) => {
  return fetch(`${API_BASE_URL}/api/quotations/query/${queryID}`, {
           headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        }).then(res => res.json()).then(data => toCamelCase(data));
};
